import { useState, useEffect, createContext } from "react";
import { completePaymentAPI, createOrderAPI, getSubscriptionPlan, registerUserAPI, sendOtpAPI } from "./API";


const DataProvider = ({ children }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await getSubscriptionPlan();
            setData(res);
        } catch (err) {
            setError("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    const sendOtp = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const res = await sendOtpAPI(data);
            return res;
        } catch (err) {
            setError("Failed to send otp");
        } finally {
            setLoading(false);
        }
    }

    const registerUser = async (data) => {
        setLoading(true);
        setError(null);
        try {
            const res = await registerUserAPI(data);
            return res;
        } catch (err) {
            setError("Failed to register user");
        } finally {
            setLoading(false);
        }
    }
    const createOrder = async (data, accessToken) => {
        setLoading(true);
        setError(null);
        try {
            const res = await createOrderAPI(data, accessToken);
            return res;
        } catch (err) {
            setError("Failed to create order");
        } finally {
            setLoading(false);
        }
    }


    const completePayment = async (data, accessToken) => {
        setLoading(true);
        setError(null);
        try {
            const res = await completePaymentAPI(data, accessToken);
            return res;
        } catch (err) {
            setError("Failed to complete payment");
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <DataContext.Provider value={{ data, loading, error, refetch: fetchData, createOrder, completePayment, sendOtp, registerUser }}>
            {children}
        </DataContext.Provider>
    );
};

export default DataProvider;

export const DataContext = createContext(undefined);